import React, {Component} from 'react';

import resizefull from "../../images/icon/resize-full.png"

import resizesmall from "../../images/icon/resize-small.png"

import fn from "../../images/icon/fn.png"

class IconView extends Component {

    render() {
        // const { title } = this.props;

        let imageUrl;
        if(this.props.buttonName === 'resize-small'){
            imageUrl = resizesmall;
        }else if(this.props.buttonName === 'resize-full'){
            imageUrl = resizefull;
        }else if(this.props.buttonName === 'FN'){
            imageUrl = fn;
        }


        //透明度
        let imageOpactiy = 1;
        if(this.props.enableAct === false){
            imageOpactiy = 0.2;
        }


        return ( <img
            className="mx-2"
                style={{width: "15px",height:"15px",opacity:`${imageOpactiy}`}}
                src={imageUrl}
             onClick={this.props.onClick}
            /> );
    }
}

export default IconView;



// WEBPACK FOOTER //
// ./src/components/common/IconView.js